module.exports = __webpack_public_path__ + "img/profile_image.fe908df5.jpg";